'use es6';

export const HEADER = 'HEADER';
export const BODY = 'BODY';
export const FOOTER = 'FOOTER'; // Root cells

export const VOID = 'VOID'; // Section delimiters

export const SECTION_DELIMITER_1 = 'SECTION_DELIMITER_1';
export const SECTION_DELIMITER_2 = 'SECTION_DELIMITER_2'; // Layouts w/o delimters, e.g. global groups

export const SECTIONLESS = 'SECTIONLESS';